const OFFICE_CENTRAL_ALLOWED_EMAILS = [
  "admin@zedro.academy",
  "quebec.javier@gmail.com",
];

export function canAccessOfficeCentral(user) {
  if (!user) return false;

  const role = String(user.role || "").toUpperCase();
  const email = String(user.email || "").trim().toLowerCase();

  const hasAllowedRole = role === "ADMIN" || role === "STAFF";
  const hasAllowedEmail = OFFICE_CENTRAL_ALLOWED_EMAILS.includes(email);

  return hasAllowedRole || hasAllowedEmail;
}